/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import 'regenerator-runtime';
import React from 'react';

import { lightTheme, Provider as ProviderV3 } from '@adobe/react-spectrum';
import renderWhenReady from '@nebula/airglow-plugin-unified-shell/dist/render.when.ready';
import App from './casing/app';
import plugins from './casing/data/plugins';

renderWhenReady(
  runtime => (
    <ProviderV3 colorScheme="light" theme={lightTheme}>
      <App plugins={plugins(runtime)} />
    </ProviderV3>
  ),
  document.getElementById('content'),
  {
    solution: {
      icon: 'AdobeExperienceCloud',
      title: 'Adobe Experience Cloud',
      shortTitle: 'AEC'
    },
    title: 'Assurance'
  }
);
